import {
  INITIATE_PAYMENT_SUCCESS,
  INITIATE_PAYMENT_FAILED,
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INITIATE_PAYMENT_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        data: action.data,
      };
    case INITIATE_PAYMENT_FAILED:
      return { ...state, status: 'error', error: action.error };
    default:
      return state;
  }
};
